import React from 'react';

function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#0f1419] via-[#1a2332] to-[#0f1419] text-white py-12 px-5 border-t border-white/10 shadow-2xl">
      <div className="max-w-7xl mx-auto">
        {/* Başlıklar Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          <h3 className="text-xl font-bold text-[#3daae1] text-center md:text-left">Hızlı Bağlantılar</h3>
          <h3 className="text-xl font-bold text-[#3daae1] text-center">Bizi Takip Edin</h3>
          <h3 className="text-xl font-bold text-[#3daae1] text-center md:text-right">İletişim</h3>
        </div>

        {/* İçerik Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Hızlı Bağlantılar - SOL */}
          <ul className="space-y-3 text-center md:text-left">
            <li>
              <a href="/" className="text-gray-300 hover:text-[#3daae1] transition-colors duration-300 inline-block">
                Ana Sayfa
              </a>
            </li>
            <li>
              <a href="/acm" className="text-gray-300 hover:text-[#3daae1] transition-colors duration-300 inline-block">
                ACM Nedir?
              </a>
            </li>
            <li>
              <a href="/etkinlikler" className="text-gray-300 hover:text-[#3daae1] transition-colors duration-300 inline-block">
                Etkinlikler
              </a>
            </li>
            <li>
              <a href="/iletisim" className="text-gray-300 hover:text-[#3daae1] transition-colors duration-300 inline-block">
                İletişim
              </a>
            </li>
            <li>
              <a href="/duyurular" className="text-gray-300 hover:text-[#3daae1] transition-colors duration-300 inline-block">
                Duyurular
              </a>
            </li>
            <li>
              <a href="/uye-ol" className="text-gray-300 hover:text-[#3daae1] transition-colors duration-300 inline-block">
                Üye Ol
              </a>
            </li>
          </ul>

          {/* Sosyal Medya İkonları - ORTA */}
          <div className="flex justify-center gap-5">
            <a
              href="https://www.instagram.com/acmigdir/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 rounded-full flex items-center justify-center text-white text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-pink-500/50"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/acm-igdir"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-[#0077b5] rounded-full flex items-center justify-center text-white text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-500/50"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://x.com/acmigdir"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-black rounded-full flex items-center justify-center text-white text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-gray-500/50"
              aria-label="X (Twitter)"
            >
              <i className="fab fa-x-twitter"></i>
            </a>
            <a
              href="https://www.youtube.com/@ACMIgdir"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-red-500/50"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>

          {/* İletişim Detayları - SAĞ */}
          <ul className="space-y-4 text-gray-300 text-center md:text-right">
            <li className="flex items-center justify-center md:justify-end gap-3">
              <a href="mailto:iletisim@acmigdir.org" className="hover:text-[#3daae1] transition-colors duration-300">
                iletisim@acmigdir.org
              </a>
              <i className="fa fa-envelope text-[#3daae1]"></i>
            </li>
            <li className="flex items-center justify-center md:justify-end gap-3">
              <span className="leading-relaxed text-center md:text-right">Iğdır Üniversitesi Şehit Bülent Yurtseven Kampüsü</span>
              <i className="fa fa-map-marker-alt text-[#3daae1] flex-shrink-0"></i>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="w-full text-center text-gray-400 text-sm mt-10 pt-6 border-t border-gray-600/50">
        <p>© 2025 ACM Iğdır</p>
      </div>
    </footer>
  );
}

export default Footer;
